"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _get = _interopRequireDefault(require("lodash/get"));

var _overflow = require("../../hooks/overflow");

var numLabelsStripped = 2;

var LabelStrip = function LabelStrip(_ref) {
  var children = _ref.children,
      beforeLabel = _ref.beforeLabel;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isShowAll = _useState2[0],
      setIsShowAll = _useState2[1];

  var labelsRef = (0, _react.useRef)();
  var labelItemsRef = (0, _react.useRef)();

  var _useOverflow = (0, _overflow.useOverflow)(labelsRef, labelItemsRef),
      isOverflow = _useOverflow.isOverflow,
      labelWidths = _useOverflow.widths,
      width = _useOverflow.width,
      ready = _useOverflow.ready;

  labelItemsRef.current = _react["default"].Children.map(children, function () {
    return /*#__PURE__*/(0, _react.createRef)();
  });

  var nodes = _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      ref: (0, _get["default"])(labelItemsRef, "current[".concat(index, "]"), undefined)
    });
  }); // Fill up available space with labels


  var reduced = labelWidths.reduce(function (prev, curr, index) {
    if (curr > prev.remaining) {
      return prev;
    }

    return {
      remaining: prev.remaining - curr,
      nodes: [].concat((0, _toConsumableArray2["default"])(prev.nodes), [nodes[index]])
    };
  }, {
    remaining: !(0, _isNil["default"])(labelsRef.current) ? width : 0,
    nodes: []
  }); // Final label items to render remove the last item to make space for +x more

  var _final = reduced.nodes.slice(0, -numLabelsStripped); // Shows the number of hidden labels


  var numHidden = nodes.length - _final.length;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex items-center self-center w-full disable-scrollbars whitespace-no-wrap', {
      invisible: !ready,
      'overflow-hidden': !isShowAll,
      'overflow-scroll': isShowAll
    }),
    ref: labelsRef
  }, !ready || !isOverflow || isShowAll ? nodes : _final, beforeLabel, isOverflow && numHidden > 0 && !isShowAll && /*#__PURE__*/_react["default"].createElement("span", {
    onClick: function onClick() {
      return setIsShowAll(true);
    },
    className: "text-light cursor-pointer text-sm font-bold h-6 truncate"
  }, "+ ".concat(numHidden, " more")));
};

var _default = LabelStrip;
exports["default"] = _default;
//# sourceMappingURL=LabelStrip.js.map